module.exports = __webpack_public_path__ + "static/media/play_store.0a248f0e.png";